import { useStaticQuery, graphql } from "gatsby"

// only one query per file, so we put each url in its own file

export const useCoachLearningPlatformUrl = () => {
  const data = useStaticQuery(coachLearningPlatformUrlQuery)
  return (data.pssHeaderLink || {}).url
}

const coachLearningPlatformUrlQuery = graphql`
  query CoachLearningPlatformUrlQuery {
    pssHeaderLink(key: { eq: "coachLearningPlatformUrl" }) {
      url
    }
  }
`
